import { CreateToolbar, MapToolType } from "../createToolbar";
import { ToolbarButtonId, getToolbarId } from "./toolbarEnum";

export class ToolbarPointHandler {
    constructor(private toolbar: CreateToolbar) {}

    handle = (idElement: string, containerId: string) => {
        const listBtnToggle = [
            getToolbarId(ToolbarButtonId.POINT_TOOL, containerId),
            getToolbarId(ToolbarButtonId.POINT_PICK, containerId),
            getToolbarId(ToolbarButtonId.ERASER_POINT, containerId),
            getToolbarId(ToolbarButtonId.EYE_SHOW_POINT, containerId),
            getToolbarId(ToolbarButtonId.EYE_HIDE_POINT, containerId),
            getToolbarId(ToolbarButtonId.REMOVE_ALL_POINT, containerId),
            getToolbarId(ToolbarButtonId.DONE_POINT, containerId)
        ];

        const listIdGroup = [
            getToolbarId(ToolbarButtonId.DIM_GROUP, containerId),
            getToolbarId(ToolbarButtonId.POINT_GROUP, containerId),
            getToolbarId(ToolbarButtonId.LABEL_PROPERTIES, containerId),
            getToolbarId(ToolbarButtonId.GROUP_DATA, containerId),
            getToolbarId(ToolbarButtonId.DATA_ELEMENT, containerId),
            getToolbarId(ToolbarButtonId.GROUP_CAMERA, containerId),
            getToolbarId(ToolbarButtonId.FLY_CAMERA, containerId)
        ];

        const btnActiveGr = listBtnToggle.slice(1, listBtnToggle.length - 2);

        this.toolbar._unActiveBtnInGroup(listBtnToggle);
        this.toolbar._activeBtnInGroup(btnActiveGr, idElement);

        if (idElement === getToolbarId(ToolbarButtonId.POINT_TOOL, containerId)) {
            if (this.toolbar._activeBtnClippingPlane) {
                this.toolbar.ToolBarActionClippingPlane(getToolbarId(ToolbarButtonId.CLIPPING_PLANE_DONE, containerId), containerId);
            }
            this.toolbar.deactivateOtherTools(MapToolType.POINT);
            this.toolbar._showHideElementsByID(listIdGroup, false);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.POINT_GROUP, containerId), true);
            this.toolbar._showHideElementsByID(listBtnToggle, true);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.POINT_TOOL, containerId), false);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.GROUP_CAMERA, containerId), false);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.GROUP_DATA, containerId), false);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.GROUP_NOTE, containerId), false);
            this.toolbar._activeBtn(getToolbarId(ToolbarButtonId.POINT_PICK, containerId), true);

            this.toolbar._contextMenu!.destroyContextMenu();
            this.toolbar._pointCesium!.showHideAllPointXYZs(true);
            this.toolbar._pointCesium!.createPointXYZCesium(this.toolbar._espChoose);
        }
        else if (idElement === getToolbarId(ToolbarButtonId.POINT_PICK, containerId)) {
            this.toolbar._pointCesium!.showHideAllPointXYZs(true);
            this.toolbar._pointCesium!.createPointXYZCesium(this.toolbar._espChoose);
        }
        else if (idElement === getToolbarId(ToolbarButtonId.ERASER_POINT, containerId)) {
            this.toolbar._pointCesium!.showHideAllPointXYZs(true);
            this.toolbar._pointCesium!.removePointXYZCesium();
        }
        else if (idElement === getToolbarId(ToolbarButtonId.EYE_SHOW_POINT, containerId)) {
            this.toolbar._pointCesium!.showHideAllPointXYZs(true);
        }
        else if (idElement === getToolbarId(ToolbarButtonId.EYE_HIDE_POINT, containerId)) {
            this.toolbar._pointCesium!.showHideAllPointXYZs(false);
        }
        else if (idElement === getToolbarId(ToolbarButtonId.REMOVE_ALL_POINT, containerId)) {
            this.toolbar._pointCesium!.removeAllPointXYZs();
        }
        else if (idElement === getToolbarId(ToolbarButtonId.DONE_POINT, containerId)) {
            this.toolbar._pointCesium!.refreshAllAction();
            this.toolbar._pointCesium!.showHideAllPointXYZs(false);
            this.toolbar._showHideElementsByID(listIdGroup, true);
            this.toolbar._showHideElementsByID(listBtnToggle, false);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.POINT_TOOL, containerId), true);

            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.GROUP_CAMERA, containerId), true);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.GROUP_DATA, containerId), true);
            this.toolbar._showHideElementByID(getToolbarId(ToolbarButtonId.GROUP_NOTE, containerId), true);
            this.toolbar._contextMenu!.createContextMenu();
        }
    };
}
